/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function ArrowUpIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="m21.093 6.5 10.493 11c.562.625.562 1.563-.062 2.125s-1.562.563-2.124-.062l-7.87-8.313V32.5c0 .875-.687 1.5-1.499 1.5-.874 0-1.499-.625-1.499-1.5V11.25L10.6 19.563c-.562.625-1.499.625-2.123.062s-.625-1.562-.063-2.125l10.493-11c.312-.312.687-.5 1.124-.5.375 0 .75.188 1.062.5"/>}
        </IconWrapper>);
}
